import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
// import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header {
  // themeService = inject(ThemeService);
}
